import { render } from "./RecommendedProductsContainer.vue?vue&type=template&id=0a0686f4&scoped=true"
import script from "./RecommendedProductsContainer.vue?vue&type=script&lang=js"
export * from "./RecommendedProductsContainer.vue?vue&type=script&lang=js"

import "./RecommendedProductsContainer.vue?vue&type=style&index=0&id=0a0686f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0686f4"]])

export default __exports__